import * as React from 'react';
import { PikCheckbox } from '../../../../ui/pik_checkbox/pik_checkbox';

interface IHandOverFilterProps {
  value: boolean;
  onChange(value: boolean): void;
}

export class HandOver extends React.PureComponent<IHandOverFilterProps> {
  public render() {
    const { value, onChange } = this.props;

    return <PikCheckbox label="готовые квартиры" value={value} onValueChange={onChange} />;
  }
}
